export function createVoucherExportWorker() {
  return new Worker(new URL('./voucherExport.worker.js', import.meta.url));
}
